import { create } from "zustand";

interface WorkbenchState {
  selected: Set<string>;
  toggle: (name: string) => void;
  selectAll: (names: string[]) => void;
  clear: () => void;
  has: (name: string) => boolean;
}

export const useWorkbench = create<WorkbenchState>((set, get) => ({
  selected: new Set(),
  toggle: (name) =>
    set((s) => {
      const next = new Set(s.selected);
      if (next.has(name)) next.delete(name);
      else next.add(name);
      return { selected: next };
    }),
  selectAll: (names) => set({ selected: new Set(names) }),
  clear: () => set({ selected: new Set() }),
  has: (name) => get().selected.has(name),
}));